import React from 'react';

import { LayoutSingleColumn, NamedLink, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import css from './InfoPage.module.css';

const steps = [
  {
    number: '01',
    title: 'Choose your date and time',
    text: 'Tell us when you need glam so you can focus on artists who may suit that appointment.',
  },
  {
    number: '02',
    title: 'Compare artists in one place',
    text: 'Browse portfolios, pricing, and studio or mobile options without searching profile after profile.',
  },
  {
    number: '03',
    title: 'Send one clear request',
    text: 'Choose an artist and send the booking details they need to review your request.',
  },
  {
    number: '04',
    title: 'Get confirmed',
    text: 'Payment is processed only after the artist accepts the booking.',
  },
];

const HowItWorksPage = () => (
  <Page title="How Hotline Glam Works">
    <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
      <main id="main-content" className={css.page}>
        <section className={css.intro}>
          <span className={css.eyebrow}>How it works</span>
          <h1>Last-minute glam, made simpler.</h1>
          <p className={css.lead}>
            Find Sydney makeup artists, compare your options and request a booking in one space.
          </p>
        </section>
        <section className={css.steps} aria-label="Booking steps">
          {steps.map(step => (
            <article className={css.step} key={step.number}>
              <span className={css.number}>{step.number}</span>
              <div>
                <h2>{step.title}</h2>
                <p>{step.text}</p>
              </div>
            </article>
          ))}
        </section>
        <section className={css.bottomCta}>
          <h2>Makeup emergency? We’ve got you.</h2>
          <NamedLink name="SearchPage" className={css.primary}>Find an artist</NamedLink>
        </section>
      </main>
    </LayoutSingleColumn>
  </Page>
);

export default HowItWorksPage;
